import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnInit {

  iframeLoaded = false;

  iframeSrc: any;

  @ViewChild('iframe') iframe: ElementRef;

  constructor(
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit() {
    // tslint:disable-next-line:max-line-length
    this.iframeSrc = this.sanitizer.bypassSecurityTrustResourceUrl('//api2.lunchgate.ch/menu/box/id/1158/menus/4/css/http:||nooba.ch|typo3conf|ext|nooba|Resources|Public|StyleSheet|default.css');
    setTimeout(() => {
      this.iframe.nativeElement.addEventListener('load', () => {
        this.iframeLoaded = true;
      });
    }, 10);
  }

}
